<template>
  <div class="cart-button">
    <div v-if="(flash_day&&flash_day=='tomorrow')||showNotStarted" class="cart-button__add"
         style="background-color:#C0C0C0;text-align:center">秒杀未开始
    </div>
    <div v-else-if="!flash_day&&showGotoLink" class="cart-button__add"
         style="background-color:#E3170D;text-align:center"
         @click="goToLink">{{coinName}}不足，快去赚{{coinName}}
    </div>
    <div v-else :mg-stat-lob="`goods_id=${goodsId}&goods_num=${nowGoodsNum}`" class="cart-button__add"
         mg-stat-click mg-stat-custom="cont=立即兑换&label=btn&direct=cntp&addr=w_sku"
         @click="addCart('addCart')">立即兑换
    </div>
  </div>
</template>
<script>
import Env from 'utils/env';
import MgtvApi from 'MgtvApi';

export default {
  props: ['showGotoLink', 'flash_day', 'flashSaleInfo', 'goodsId', 'nowGoodsNum'],
  data() {
    return {
      showNotStarted: false,
    };
  },
  computed: {},
  created() {
    this.interval = setInterval(() => {
      if (this.flashSaleInfo && this.flashSaleInfo.startTime) {
        if (new Date().getTime() < this.flashSaleInfo.startTime) {
          this.showNotStarted = true;
        } else {
          this.showNotStarted = false;
          clearInterval(this.interval);
        }
      }
    }, 1000);
  },
  methods: {
    addCart(type) {
      this.$emit('change', type);
    },
    goToLink() {
      if (this.$route.query.from === 'jubaopen_shop_home') {
        const { isMgtvApp, isIOS } = Env;
        console.log('isMgtvApp:', isMgtvApp);
        if (!isMgtvApp) {
          const schemaLink = 'imgotv://cornucopia';
          const universalLink = `https://msite.api.mgtv.com/download.html?type=2&content=${schemaLink}`;
          const androiDdownUrl = `http://a.app.qq.com/o/simple.jsp?pkgname=com.hunantv.imgo.activity&android_schema=${schemaLink}`;
          window.location.href = isIOS ? universalLink : androiDdownUrl;
        } else {
          MgtvApi.jumpPage({
            url: 'imgotv://cornucopia',
          });
        }
      } else {
        window.location.href = 'https://app.mgtv.com/credits/index.html#/?from=title';
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>

<style lang="scss" scoped>
.cart-button {
  @media screen and (min-width: 1025px) {
    width: 500px; /*no*/
    left: calc(50% - 250px); /*no*/
    right: calc(50% - 250px); /*no*/
  }
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  background: #fff;
  color: #fff;
  z-index: 10;

  &__add {
    flex: 1;
    height: 110px;
    line-height: 110px;
    text-align: center;
    font-size: 30px;
  }

  &__add {
    background: #ff5f00;
    color: #fff;
  }
}
</style>
